// 로고 이름·경로 데이터 한 벌 — 화면 로고(brand-logo.tsx)·앱 아이콘·디자인 동기화가 같이 쓴다. 글꼴 단위(위가 +y)라 그릴 때 scale(1,-1) 로 뒤집는다.

// 글자로 쓰는 이름(탭 제목·메타·로고 aria-label).
export const BRAND_NAME = "buildpy";

export interface Glyph {
  /** 글자 시작 x(글꼴 단위). */
  x: number;
  d: string;
}

/** build — 잉크색. */
export const BUILD_GLYPHS: Glyph[] = [
  { x: 0, d: "M110 0H444V176H454C498 78 594 -16 760 -16C1002 -16 1196 174 1196 542C1196 924 990 1100 762 1100C588 1100 496 998 454 900H446V1448H110ZM440 544C440 724 514 836 646 836C778 836 850 720 850 544C850 364 776 248 646 248C516 248 440 364 440 544Z" },
  { x: 1266, d: "M808 468C808 338 724 266 620 266C512 266 446 340 446 458V1086H108V394C108 146 258 -14 480 -14C644 -14 764 70 812 200H824V0H1144V1086H808Z" },
  { x: 2520, d: "M108 0H446V1086H108ZM278 1216C374 1216 454 1288 454 1378C454 1468 374 1540 278 1540C182 1540 104 1468 104 1378C104 1288 182 1216 278 1216Z" },
  { x: 3074, d: "M446 1448H108V0H446Z" },
  { x: 3628, d: "M506 -16C672 -16 768 78 812 176H822V0H1156V1448H820V900H812C770 998 678 1100 504 1100C276 1100 70 924 70 542C70 174 264 -16 506 -16ZM620 248C490 248 416 364 416 544C416 720 488 836 620 836C752 836 826 724 826 544C826 364 750 248 620 248Z" },
];

/** py — 브랜드색. p–y 아래가 U자로 이어진다. 워드마크에서는 PY_OFFSET 만큼 밀어 쓴다. */
export const PY_GLYPHS: Glyph[] = [
  { x: 0, d: "M108 -208C108 -330 186 -408 308 -408H446V176H454C496 78 592 -16 760 -16C1000 -16 1194 174 1194 542C1194 924 990 1100 760 1100C588 1100 494 998 454 900H442V1086H108ZM438 544C438 724 514 836 644 836C776 836 848 720 848 544C848 364 776 248 644 248C514 248 438 364 438 544ZM400 -408H1464V-146H400Z" },
  { x: 1264, d: "M304 -408C558 -408 682 -284 742 -106L1154 1086H798L592 306H580L374 1086H22L408 -38L396 -72C374 -124 340 -146 276 -146H100V-408H304Z" },
];

export const PY_OFFSET = 4894;

export const WORDMARK_VIEWBOX = { x: 0, y: -1500, width: 7334, height: 1950 };

/** 앱 아이콘 칸 — py 가 가운데 오는 정사각형과 둥근 모서리 반경. */
export const ICON_BOX = { x: -677.4, y: -2286.4, size: 3880.8, radius: 853.8 };

export const viewBoxOf = (b: { x: number; y: number; width: number; height: number }): string => `${b.x} ${b.y} ${b.width} ${b.height}`;

export const ICON_VIEWBOX = viewBoxOf({ x: ICON_BOX.x, y: ICON_BOX.y, width: ICON_BOX.size, height: ICON_BOX.size });
